import AxiosClient from '../../repositories/clients/axios'
import messages from '../../constants'
import { Order } from '../../entity/Order'
import { redirectInvalidUser } from '../../functions'

export default {
  namespaced: true,
  state: {
    orderNumber: null,
    order: null,
    products: [],
    product: null,
    error: null,
    loading: true,
    trackingData: {},
    payments: [],
    invoice: {}
  },
  mutations: {
    setLoading (state, value) {
      state.loading = value
    },
    orderNumber (state, value) {
      state.orderNumber = value
    },
    setOrder (state, order) {
      state.order = order
    },
    setProducts (state, products) {
      state.products = products
    },
    setError (state, error) {
      state.error = error
    },
    setTracking (state, tracking) {
      state.trackingData = tracking
    },
    setPayments (state, payments) {
      state.payments = payments
    },
    setInvoice (state, invoice) {
      state.invoice = invoice
    }
  },
  actions: {
    loadOrder (context) {
      context.commit('setProducts', [])
      context.commit('setOrder', new Order())
      context.commit('setLoading', true)
      context.commit('setError', null)

      const url = process.env.VUE_APP_PANEL_ORDERS_ITEMS.replace('{orderNumber}', context.state.orderNumber)

      const response = AxiosClient(true).get(url)

      response
        .then(response => response.data)
        .then(data => {
          if (data.code === 400 || data.code === 404) {
            throw { data: messages.NO_ORDERS }
          }

          if (data.code === 401) {
            redirectInvalidUser()
            return
          }

          if (data.code === 500 || data.code === 504) {
            throw { data: messages.ERROR_AWAIT }
          }

          if (Object.keys(data).length !== 0) {
            const order = new Order(data)
            context.commit('setOrder', order)
            if (order.products != null) {
              context.commit('setProducts', order.products)
            }
            if (order.payments[0]) {
              context.commit('setPayments', order.payments)
            }
            if (order.invoice) {
              context.commit('setInvoice', order.invoice)
            }
          } else {
            throw { data: messages.NO_ORDERS }
          }

          context.commit('setLoading', false)
        }).catch(error => {
          let errorMessage = messages.NO_ORDERS
          if (error !== undefined && error.data != null) {
            errorMessage = error.data
          }
          context.commit('setError', errorMessage)
          context.commit('setLoading', false)
        })
    },
    setOrderNumber (context, value) {
      context.commit('orderNumber', value)
      context.dispatch('loadOrder')
    },
    setLoading (context, value) {
      context.commit('setLoading', value)
    },
    setTracking (context, tracking) {
      context.commit('setTracking', tracking)
    },
    setPayments (context, payments) {
      context.commit('setPayments', payments)
    },
    setInvoice (context, invoice) {
      context.commit('setInvoice', invoice)
    }
  }
}
